export default function Hero() {
  const scrollToContact = () => {
    const element = document.getElementById('contact');
    if (element) {
      element.scrollIntoView({ behavior: 'smooth' });
    }
  };

  return (
    <section className="relative h-[85vh] flex items-center overflow-hidden">
      <div className="absolute inset-0">
        <img
          src="https://readdy.ai/api/search-image?query=Sophisticated%20modern%20Japanese%20luxury%20residential%20interior%20with%20natural%20light%20streaming%20through%20large%20windows%2C%20minimalist%20elegant%20design%20with%20clean%20lines%2C%20warm%20wood%20tones%20and%20neutral%20colors%2C%20high-end%20architectural%20photography%2C%20professional%20real%20estate%20photography%20style%2C%20desaturated%20and%20calm%20atmosphere%2C%20subtle%20shadows%2C%20premium%20quality&width=1920&height=1080&seq=hero-bg-001&orientation=landscape"
          alt="Premium residential interior"
          className="w-full h-full object-cover object-center"
        />
        <div className="absolute inset-0 bg-gradient-to-b from-transparent via-black/20 to-black/25"></div>
      </div>

      <div className="relative z-10 text-white max-w-[1120px] mx-auto px-8 w-full">
        <h2
          className="text-[56px] leading-[1.4] font-medium mb-8"
          style={{ fontFamily: "'Noto Serif JP', serif", textShadow: '0 1px 2px rgba(0,0,0,0.3)' }}
        >
          信頼と実績で選ばれる
          <br />
          高級住宅専門の
          <br />
          不動産仲介サービス
        </h2>

        <p
          className="text-[16px] font-light leading-relaxed mb-14 opacity-90"
          style={{ fontFamily: "'Noto Sans JP', sans-serif" }}
        >
          お客様一人ひとりの理想とライフスタイルに寄り添った、
          <br />
          最適な住まいをご提案いたします。
        </p>

        <button
          onClick={scrollToContact}
          className="group flex items-center gap-3 w-[220px] h-[56px] px-8 bg-[#1A2B3C] text-white rounded-full text-[14px] tracking-[0.12em] font-medium hover:bg-[#2A3B4C] transition-all duration-300 shadow-lg whitespace-nowrap cursor-pointer"
          style={{ fontFamily: "'Noto Sans JP', sans-serif" }}
        >
          <span>資料請求・お問い合わせ</span>
        </button>
      </div>
    </section>
  );
}
